import axios from "axios";

export const getImages = async () => {
  const response = await axios.get(
    "https://fake.mobiusframe.com/api/images/fake-it"
  );

  return response.data;
};
